export default __webpack_public_path__ + "static/media/Cigdem.70a2f8d5.jpeg";